// lib/gtag.ts
// Google Ads conversion tracking utilities

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

// Google Ads conversion IDs
export const GA_ADS_ID = 'AW-11303282550';

export const CONVERSION_IDS = {
  CONTACT_FORM: 'AW-11303282550/ICFjCJ31zIsZEPbO6Y0q',
  PHONE_CALL: 'AW-11303282550/lZJDCLGUgvAYEPbO6Y0q',
  LANDING_THANK_YOU: 'AW-11303282550/iN42CKz-zIsZEPbO6Y0q',
  NEXHEALTH_CLICK: 'AW-11303282550/Sm6_CMLMh-kcEPbO6Y0q',
} as const;

// Track contact form submission conversion
export const trackContactConversion = (callback?: () => void) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: CONVERSION_IDS.CONTACT_FORM,
      event_callback: callback,
    });
  } else if (callback) {
    callback();
  }
};

// Track phone call click conversion
export const trackPhoneCallConversion = (callback?: () => void) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: CONVERSION_IDS.PHONE_CALL,
      event_callback: callback,
    });
  } else if (callback) {
    callback();
  }
};

// Track an outbound click to NexHealth. This records booking intent, not a
// confirmed appointment.
export const trackNexHealthClickConversion = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: CONVERSION_IDS.NEXHEALTH_CLICK,
    });
  }
};

// Track landing page thank you / successful submission conversion
export const trackLandingThankYouConversion = (callback?: () => void) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: CONVERSION_IDS.LANDING_THANK_YOU,
      event_callback: callback,
    });
  } else if (callback) {
    callback();
  }
};

// Generic conversion tracking function
export const trackConversion = (
  conversionId: string,
  url?: string
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const callback = () => {
      if (typeof url !== 'undefined') {
        window.location.href = url;
      }
    };
    window.gtag('event', 'conversion', {
      send_to: conversionId,
      event_callback: callback,
    });
    return false;
  }
  // Fallback if gtag not loaded
  if (typeof url !== 'undefined') {
    window.location.href = url;
  }
  return false;
};
